import axios from "../axios";
import { AUTH_API_URL } from "../constants/api";
import { getImageUrl } from "../utils/media";

export { detectMessageType } from "./messageTypes";

const resolveUploadUrl = (data) => {
  if (!data) return "";
  if (typeof data === "string") return getImageUrl(data);
  if (typeof data === "object") {
    const path =
      data.url ||
      data.path ||
      data.file_path ||
      data.filePath ||
      data.full_url ||
      data.fullUrl ||
      data.link ||
      "";
    return getImageUrl(path);
  }
  return "";
};

/**
 * Upload a chat attachment via the general upload API.
 * Returns an absolute media URL.
 */
export const uploadChatFile = async (file, { source = "chat/image" } = {}) => {
  if (!file) {
    throw new Error("No file selected");
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("source", source);

  const { data } = await axios.post(
    `${AUTH_API_URL}/general/upload-file`,
    formData,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  const url = resolveUploadUrl(data?.data ?? data);
  if (!url) {
    throw new Error(data?.message || "Upload failed");
  }
  return url;
};
